module.exports = __webpack_public_path__ + "media/components/Influencers/Layouts/Navigation/projectIcon-4ed61cfa0b60e7a3d2d3777f4918a970.svg";